import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchAppTypesAsync, fetchTeamTypesAsync } from '@/modules/global/global.slice';

import { AppDispatch } from '@/stores/store';
import { fetchUserInfoAsync } from '@/modules/user/user.slice';

type GlobalContextType = {
  children: React.ReactElement;
};

export const GlobalContext = ({ children }: GlobalContextType) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchAppTypesAsync());
    dispatch(fetchTeamTypesAsync());
    dispatch(fetchUserInfoAsync());
  }, []);
  return children;
};
